// removed by extract-text-webpack-plugin
module.exports = {"dataCard":"data-card-row-module__dataCard___2llNE","dataCardHeader":"data-card-row-module__dataCardHeader___1PESg","dataCardRow":"data-card-row-module__dataCardRow___3YZ4K","dataCardRowLeft":"data-card-row-module__dataCardRowLeft___3BLJx","dataCardRowRight":"data-card-row-module__dataCardRowRight___2DdIn","dataCardRowTitle":"data-card-row-module__dataCardRowTitle___2zw5-","selectWrapper":"data-card-row-module__selectWrapper___nP5Gj","subCategoryDropdown":"data-card-row-module__subCategoryDropdown___iBly-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/data-card-row/data-card-row.module.scss
// module id = 660
// module chunks = 0 1